import React from 'react';
import { RadioGroup } from '@ff-os/shared-react/components/radio-group/RadioGroup';
import { ColorChoice } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeOptions';
import { ColorAttributeRadio } from './ColorAttributeRadio';

export const ColorAttributeRadioGroup = ({
    selected, choices, update
}: Props) => (
    <RadioGroup>
        {choices.map(c => (
            <ColorAttributeRadio key={c.value}
                value={c.value} label={c.label} options={c.options}
                onClick={update} active={c.value === selected.value} />
        ))}
    </RadioGroup>
);

type Props = {
    selected: ColorChoice;
    choices: ColorChoice[];
    update: (value: string) => void;
};